module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad2/img_students-d39664da961fdbc0675a13bfe80268a4.png";